// Shared status pill for the support inbox (PROP-163). Used by both the
// list (Inbox.tsx) and detail (Thread.tsx) surfaces so a thread's status
// reads identically wherever it appears — including the in-place flip to
// "replied" after a reply dispatches.

import type { SupportStatus } from "@/lib/support-api";

const PALETTE: Record<SupportStatus, { bg: string; fg: string }> = {
  // New — awaiting a first operator reply (warm/attention tone).
  new: { bg: "#f0e7d0", fg: "#6b5320" },
  // Replied — answered, awaiting the user (accent tone).
  replied: { bg: "var(--accent-soft)", fg: "var(--accent)" },
  // Closed — resolved (muted tone).
  closed: { bg: "var(--surface-2)", fg: "var(--ink-3)" },
};

export function SupportStatusPill({ status }: { status: SupportStatus }) {
  const p = PALETTE[status] ?? PALETTE.new;
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 12,
        background: p.bg,
        color: p.fg,
        fontSize: 10.5,
        fontWeight: 500,
        letterSpacing: "0.02em",
        textTransform: "capitalize",
        fontFamily: "var(--font-ui)",
      }}
    >
      {status}
    </span>
  );
}
